module.exports = __webpack_public_path__ + "img/1.25_Russian_road_sign.6a7e253c.svg";